/**
 * Klaviyo Form Submission Tracker
 * Uses official Klaviyo event API to track form submissions
 * Only tracks non-PII data to comply with Google Analytics ToS
 * Documentation: https://developers.klaviyo.com/en/docs/track_klaviyo_form_activity_using_javascript
 */

(function() {
  // Ensure dataLayer exists
  window.dataLayer = window.dataLayer || [];

  // Listen for official Klaviyo form events
  window.addEventListener('klaviyoForms', function(e) {
    // Only track actual submissions (not opens, closes, etc.)
    if (e.detail.type === 'submit') {
      window.dataLayer.push({
        event: 'klaviyo_form_submit',
        klaviyo_form_id: e.detail.formId,
        klaviyo_form_timestamp: new Date(e.timeStamp).toISOString(),
        page_url: window.location.href,
        page_title: document.title
      });
    }
  });
})();
